import { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Row, Tab, Tabs } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";

// img
import { useChatterProgramDetailsQuery, useMarkAttendanceMutation, useRemoveAssignedLessonMutation, useRemoveProgramUserMutation, useUpdateChatterProgramMutation } from "store/services/chatter/program";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { CHATTER_PROGRAM_EDIT, CHATTER_PROGRAM_LIST } from "config/paths";
import moment from "moment";
import TableLayout from "components/TableLayout";
import AddChatterLessonPop from "components/Modals/AddLessonPop";
import { CommonToolTip, CstmPagination } from "components/Common/Common";
import { DeleteIcon } from "Assets/icons";
import { formatString, successMessageToast } from "helpers/common";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ShowAttachedFilesPop from "components/Modals/ViewAttachedFilesPop";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import { useGetNoteQuery } from "store/services/note";
import AddProgramUserPop from "components/Modals/AddProgramUserPop";
import { cloneDeep } from "lodash";
import Attendance from "./Components/Attendance";
import AssignChatterLessonV2 from "components/Modals/AssignChatterLessonPopV2";
import parse from "html-react-parser"
import confirmDialog from "utils/confirmationDialog";
import { STATUS_OPTIONS } from "config/constants";

const ChatterProgramFilesDetail = () => {

  const { id: programId } = useParams();
  const navigate = useNavigate();
  const membersPageSize = 10;

  const [showModal, setShowModal] = useState(false);
  const [showAttachedFileModal, setShowAttachedFileModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [tableRow, setTableRow] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [activeTab, setActiveTab] = useState("chatter");

  const { data: programDetails, isLoading, isFetching, refetch } = useChatterProgramDetailsQuery(programId);
  const [removeLesson, { isLoading: removeLessonLoading }] = useRemoveAssignedLessonMutation();
  const [removeMember, { isLoading: removeMemberLoading }] = useRemoveProgramUserMutation();
  const [updateProgram, { isLoading: updateProgramLoading }] = useUpdateChatterProgramMutation();

  const [markAttendance, { isLoading: markAttendanceLoading }] = useMarkAttendanceMutation();

  const [members, setMembers] = useState([]);
  const [programMembers, setProgramMembers] = useState([]);

  const { data: noteDetails } = useGetNoteQuery({ clientId: programId, moduleName: "chatter-program-profile" });

  const column = [
    {
      head: "Lesson Name",
      accessor: "name",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.lessonProgram?.title || "--"}</h6>
      )
    },
    {
      head: "Description",
      accessor: "description",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="cell-text-ellipsis">{item?.lessonProgram?.description ? parse(item?.lessonProgram?.description || "--") : "--"}</h6>
      )
    },
    {
      head: "Files",
      accessor: "files",
      isComponent: true,
      component: (item, ind) => (
        <>
          <Button className="d-flex align-items-center justify-center rounded-pill  fw-sbold border"
            style={{ fontFamily: "Merriweather", color: "#AEAEAE" }}
            variant="transparent"
            onClick={() => {

              if (item?.lessonProgram?.files?.length) {
                setFiles(item?.lessonProgram?.files || []);
                setShowAttachedFileModal(true);
              };
            }}
          >
            {item?.lessonProgram?.files?.length || 0} Files
            <span className="icn ms-1">{fileIcon}</span>
          </Button>
        </>
      )
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <CommonToolTip
            text={"Delete"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => {

                if (!removeLessonLoading && !isFetching) {
                  setCurrentEntry(item);
                  setShowModal(true);
                }
              }}
            >
              <DeleteIcon />
            </Button>}
          />
        </div>
      ),
    },
  ];

  const memberColumn = [
    {
      head: "Last Name",
      accessor: "name",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item?.programMemberData?.lastname || "--"}</h6>
      )
    },
    {
      head: "First Name",
      accessor: "name",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item?.programMemberData?.firstname || "--"}</h6>

      )
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <CommonToolTip
            text={"Delete"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={(e) => {

                setCurrentEntry(item);
                setShowDeleteUserModal(true);
              }}
            >
              <DeleteIcon />
            </Button>}
          />
        </div>
      ),
    },

  ];

  const handleAttendance = async (id, data) => {
    try {

      if (!markAttendanceLoading && !isFetching) {
        const result = await markAttendance({ id, data });
        if (!result?.error) successMessageToast(result?.data?.message);
      }

    } catch (err) {
      console.error("error mark attendance", err);
    };
  };

  const handleUpdateStatus = async (status) => {
    try {

      const isConfirm = await confirmDialog({ title: "Are you sure to update?" });
      if (!isConfirm) {
        return;
      }

      let values = {
        name: programDetails?.name,
        start_date: programDetails?.start_date,
        end_date: programDetails?.end_date,
        day: programDetails?.day,
        time: programDetails?.time?.slice(0, 5),
        location: programDetails?.location,
        therapist_head1: programDetails?.therapist_head1,
        therapist_head2: programDetails?.therapist_head2,
        funding_source: programDetails?.funding_source,
        location_type: programDetails?.location_type,
        status: status,
        lessons: programDetails?.lessonProgramMapping?.map(i => i?.lesson_id),
        days: programDetails?.days || []
      };

      const result = await updateProgram({ data: values, programId })

      if (result?.error) {
        console.error("Error creating chatter program", result.error);
      } else {
        successMessageToast(result?.data?.message);
      }
    } catch (err) {
      console.error("Error creating chatter program", err);
    }
  };

  const handleDelete = async () => {
    try {

      setShowModal(false);

      const result = await removeLesson(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error delete chatter lesson", err);
    };
  };

  const handlePageChange = (page) => {

    setCurrentPage(page);

    const indexFromSlice = (page - 1) * membersPageSize;
    setMembers(programMembers?.slice(indexFromSlice, indexFromSlice + membersPageSize));
  };

  const handleDeleteUser = async () => {
    try {

      setShowDeleteUserModal(false);

      setMembers(members.filter(x => x.member_id != currentEntry?.member_id));

      const result = await removeMember({ programId, data: { members_id: [currentEntry?.member_id] } });
      if (!result?.error) {
        successMessageToast(result?.data?.message);
        refetch();
      }


    } catch (err) {
      console.error("error delete member", err);
    };
  };

  useEffect(() => {
    if (programDetails?.programMembers) {
      const list = cloneDeep(programDetails?.programMembers)?.sort((a, b) => a?.programMemberData?.lastname < b?.programMemberData?.lastname ? -1 : a?.programMemberData?.lastname > b?.programMemberData?.lastname ? 1 : 0)?.map(i => i?.programMemberData?.client_detail?.client_type == activeTab && i)?.filter(Boolean) || [];

      setProgramMembers(list);
      setMembers(list?.slice(0, membersPageSize));
    }
  }, [programDetails, activeTab]);

  return (
    <>
      {/* <ConfirmationPop
        confirmation={showArchiveModal}
        setConfirmation={setShowArchiveModal}
        confirmHandler={handleArchive}
        type={programDetails?.status == "active" ? "archive" : "active"}
      /> */}

      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type={"delete"}
      />

      <ConfirmationPop
        confirmation={showDeleteUserModal}
        setConfirmation={setShowDeleteUserModal}
        confirmHandler={handleDeleteUser}
        type={"remove"}
      />

      <ShowAttachedFilesPop
        show={showAttachedFileModal}
        setShow={setShowAttachedFileModal}
        files={files}
      />
      {/* 
      <AddChatterLessonPop
        show={showAddModal}
        setShow={setShowAddModal}
        programDetails={programDetails}
        programId={programDetails?.id}
      /> */}

      <AddProgramUserPop
        show={showAddUserModal}
        setShow={setShowAddUserModal}
        programDetails={programDetails}
        programId={programDetails?.id}
      />
      <AssignChatterLessonV2
        show={showAddModal}
        setShow={setShowAddModal}
        programDetails={programDetails}
        programId={programDetails?.id}
      />
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>
          {
            isLoading ? <LoadingIndicator /> :
              <Row>
                {(removeLessonLoading || isFetching || removeMemberLoading || updateProgramLoading || markAttendanceLoading) && <LoadingOverlay />}
                <Col
                  lg="6"
                  className=""
                  style={{ borderRight: "1px solid #3da0aa4f" }}
                >
                  <Row>
                    <Col lg="12" className="my-3">
                      <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                        <div className="left">
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                            <li className="">
                              <Link
                                className="themeBlue fw-sbold back-to-btn"
                                to={CHATTER_PROGRAM_LIST}
                              >
                                <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                                </svg> Back
                              </Link>
                            </li>
                            <li className="">
                              <Link
                                className="themeBlue fw-sbold"
                                style={{ textDecoration: "underline" }}
                                to={CHATTER_PROGRAM_LIST}
                              >
                                Chatter Program Profiles
                              </Link>
                            </li>
                            <li className="">
                              <h5 className="m-0 fw-bold themeBlue">/ Details</h5>
                            </li>
                          </ul>
                        </div>
                        <div className="right">
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                            {/* <li className="">
                              <Button
                                className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                variant="outline-danger"
                                onClick={handleUpdateStatus}
                                disabled={isFetching || updateProgramLoading}
                              >
                                {programDetails?.status == "active" ? <span className="icn me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="14"
                                    viewBox="0 0 12 14"
                                    fill="none"
                                  >
                                    <path
                                      d="M2.48081 13.3753C2.10681 13.3753 1.78731 13.2429 1.52231 12.978C1.25744 12.713 1.125 12.3935 1.125 12.0195V2.50029H0.375V1.37529H3.75V0.711914H8.25V1.37529H11.625V2.50029H10.875V12.0195C10.875 12.3984 10.7438 12.719 10.4813 12.9815C10.2188 13.244 9.89806 13.3753 9.51919 13.3753H2.48081ZM9.75 2.50029H2.25V12.0195C2.25 12.0869 2.27162 12.1422 2.31487 12.1854C2.35812 12.2287 2.41344 12.2503 2.48081 12.2503H9.51919C9.57694 12.2503 9.62981 12.2262 9.67781 12.1781C9.72594 12.1301 9.75 12.0772 9.75 12.0195V2.50029ZM4.053 10.7503H5.17781V4.00029H4.053V10.7503ZM6.82219 10.7503H7.947V4.00029H6.82219V10.7503Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span> : null}
                                {programDetails?.status == "active" ? "Archive" : "Active"}
                              </Button>
                            </li> */}
                            <li>
                              <div className="d-flex align-items-center gap-1">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0"
                                >
                                  Status
                                </label>
                                <Dropdown onSelect={handleUpdateStatus}>
                                  <Dropdown.Toggle
                                    className="border-0 text-dark px-3 py-1 d-flex align-items-center justify-content-between fw-sbold"
                                    style={{
                                      background: "#F3F3F3",
                                      height: "32px",
                                      fontSize: "13px",
                                      borderRadius: "20px",
                                      minWidth: "130px",
                                      boxShadow: "inset 0 0 2px #ccc",
                                    }}
                                    id="dropdown-basic"
                                  >
                                    <span style={{ whiteSpace: "nowrap" }}>{formatString(programDetails?.status)}</span>
                                    <span className="ms-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10"
                                        height="5"
                                        viewBox="0 0 10 5"
                                        fill="none"
                                      >
                                        <path
                                          d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
                                          fill="#1C1B1F"
                                        />
                                      </svg>
                                    </span>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className="w-100 small p-0" style={{ fontSize: "13px" }}>
                                    {
                                      STATUS_OPTIONS?.map((item, index) => (
                                        <Dropdown.Item key={index} eventKey={item.value}>
                                          {item.label}
                                        </Dropdown.Item>
                                      ))
                                    }
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </li>
                            <li className="">
                              <Button
                                className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                variant="outline-success"
                                onClick={() => navigate(CHATTER_PROGRAM_EDIT.replace(":id", programId))}
                              >
                                <span className="icn me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_0_2439"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="18"
                                      height="18"
                                    >
                                      <rect width="18" height="18" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_0_2439)">
                                      <path
                                        d="M1.5 17.9997V15.7497H16.5V17.9997H1.5ZM4.5 12.3099H5.42737L11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L4.5 11.3825V12.3099ZM3.375 13.4349V10.9036L11.7823 2.50792C11.8909 2.3993 12.0142 2.31711 12.1523 2.26136C12.2901 2.20561 12.4336 2.17773 12.5828 2.17773C12.732 2.17773 12.8765 2.20561 13.0163 2.26136C13.156 2.31711 13.2841 2.40317 13.4004 2.51955L14.3019 3.43249C14.4183 3.54111 14.5024 3.66555 14.5543 3.8058C14.6062 3.94592 14.6321 4.0908 14.6321 4.24042C14.6321 4.38067 14.6058 4.52011 14.5532 4.65873C14.5006 4.79748 14.4168 4.9243 14.3019 5.03917L5.90625 13.4349H3.375ZM11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L11.6524 6.0963Z"
                                        fill="currentColor"
                                      />
                                    </g>
                                  </svg>
                                </span>
                                Edit
                              </Button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Col lg="12" className="my-3">
                      <div className="top d-flex align-items-center gap-10">
                        <div
                          className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                          style={{ height: 35, width: 35, background: "#DBDBDB" }}
                        >
                          {programDetails?.name[0]?.toUpperCase() || ""}
                        </div>
                        <div className="content">
                          <h6 className="m-0 themeBlue fw-sbold">{programDetails?.name || "--"}</h6>
                        </div>
                      </div>
                      <Row>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Chatter Event Name
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{programDetails?.name || "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Event Start Date
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{programDetails?.start_date ? moment(programDetails?.start_date).format("DD/MM/YYYY") : "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Event End Date
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{programDetails?.end_date ? moment(programDetails?.end_date).format("DD/MM/YYYY") : "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Days
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2 text-capitalize">{<ul>{programDetails?.days?.map(day => <li>{day}</li>)}</ul>}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Event Start Time
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{moment(programDetails?.time, "HH:mm:ss").format("hh:mm A") || "--"} </p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Location
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{programDetails?.location || "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Group Leader 1
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2 text-capitalize">{programDetails?.program_head_one ? programDetails?.program_head_one?.firstname + " " + programDetails?.program_head_one?.lastname : "--"}</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Group Leader 2
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2 text-capitalize">{programDetails?.program_head_two ? programDetails?.program_head_two?.firstname + " " + programDetails?.program_head_two?.lastname : "--"}</p>
                          </div>
                        </Col>
                        {
                          programDetails?.program_head_three &&
                          <Col md="4" sm="6" className="my-2">
                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                              <h6 className="m-0 themeBlue fw-bold">
                                {" "}
                                <span className="" style={{ color: "#3DA0AA" }}>
                                  ■
                                </span>{" "}
                                Group Leader 3
                              </h6>
                              <p className="m-0 forteen themeBlue pt-2 text-capitalize">{programDetails?.program_head_three ? programDetails?.program_head_three?.firstname + " " + programDetails?.program_head_three?.lastname : "--"}</p>
                            </div>
                          </Col>
                        }
                        <Col md="4" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Location Type
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2 text-capitalize">{programDetails?.location_type || "--"}</p>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="12" className="my-3">
                      {/* <h6 className="m-0 themeBlue fw-sbold">Notes</h6> */}
                      <NotesComponent
                        notes={noteDetails}
                        className={`${styles.formControl} form-control`}
                        module={"chatter-program-profile"}
                        client_id={programId}
                      />
                    </Col>
                    <Col lg="12" className="my-3">
                      <div className="py-3">
                        <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                          <div className="left">
                            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                              <li className="">
                                <h6 className="m-0 fw-bold themeBlue">Lesson List</h6>
                              </li>
                            </ul>
                          </div>
                          <div className="right">
                            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                              <li className="">
                                <button
                                  className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                  onClick={() => setShowAddModal(true)}
                                >
                                  <span className="icn me-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={19}
                                      height={19}
                                      viewBox="0 0 19 19"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_0_4440"
                                        maskUnits="userSpaceOnUse"
                                        x={0}
                                        y={0}
                                        width={19}
                                        height={19}
                                        style={{ maskType: "alpha" }}
                                      >
                                        {" "}
                                        <rect width="18.7197" height="18.7197" fill="#D9D9D9" />
                                      </mask>
                                      <g mask="url(#mask0_0_4440)">
                                        <path
                                          d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                          fill="white"
                                        />
                                      </g>
                                    </svg>
                                  </span>{" "}
                                  Assign New Lesson
                                </button>
                              </li>
                            </ul>
                          </div>

                        </div>

                        <div className="table-outer">
                          <TableLayout
                            data={programDetails?.lessonProgramMapping || []}
                            column={column}
                          />
                        </div>

                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col lg="6" className="">
                  <Row>
                    <Col lg="12" className="my-3">
                      <div className="py-3">
                        <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                          <div className="left">
                            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                              <li className="">
                                <h6 className="m-0 fw-bold themeBlue">Members</h6>
                              </li>
                            </ul>
                          </div>
                          <div className="right">
                            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">

                              <li>
                                <input
                                  className="form-control"
                                  placeholder="Filter By First, Last Name"
                                  onChange={(e) => {

                                    setMembers(programMembers?.filter(x => x?.programMemberData?.firstname.toLowerCase().includes(e.target.value) || x?.programMemberData?.lastname.toLowerCase().includes(e.target.value)).slice(0, membersPageSize))
                                  }}
                                />
                              </li>
                              <li className="">
                                <button
                                  className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                  onClick={() => setShowAddUserModal(true)}
                                >
                                  <span className="icn me-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={19}
                                      height={19}
                                      viewBox="0 0 19 19"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_0_4440"
                                        maskUnits="userSpaceOnUse"
                                        x={0}
                                        y={0}
                                        width={19}
                                        height={19}
                                        style={{ maskType: "alpha" }}
                                      >
                                        {" "}
                                        <rect width="18.7197" height="18.7197" fill="#D9D9D9" />
                                      </mask>
                                      <g mask="url(#mask0_0_4440)">
                                        <path
                                          d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                          fill="white"
                                        />
                                      </g>
                                    </svg>
                                  </span>{" "}
                                  Add Member
                                </button>
                              </li>
                            </ul>
                          </div>

                        </div>
                        <Tabs
                          defaultActiveKey={activeTab}
                          onSelect={(e) => setActiveTab(e)}
                          className="mt-3"
                        >
                          <Tab eventKey="chatter" title="Chatter Client">
                            <div className="table-outer">
                              <TableLayout
                                data={members || []}
                                column={memberColumn}
                              />
                              <CstmPagination
                                totalPages={Math.ceil(programMembers?.length / membersPageSize)}
                                activePage={currentPage}
                                handlePageChange={handlePageChange}
                              />
                            </div>
                          </Tab>
                          {console.log("tableResponsive", styles)}
                          <Tab eventKey="peer" title="Peer Mentor">
                            <div className="table-outer">
                              <TableLayout
                                data={members || []}
                                column={memberColumn}
                              />
                              <CstmPagination
                                totalPages={Math.ceil(programMembers?.length / membersPageSize)}
                                activePage={currentPage}
                                handlePageChange={handlePageChange}
                              />
                            </div>
                          </Tab>
                        </Tabs>
                      </div>
                    </Col>
                    <Col lg="12" className="">
                      <Row>
                        <Col lg="12" className="my-2">
                          <div className="d-flex align-items-center justify-content-between flex-wrap gap-10">
                            <h6 className="m-0 themeBlue fw-sbold">Track Attendance</h6>
                          </div>
                        </Col>
                        <Col lg="12" className="my-2">
                          <p className="m-0 d-flex  align-items-center fw-sbold py-2">
                            Event Date
                          </p>
                          <div
                            className={`${styles.tableResponsive} tableResponsive table-responsive rounded-2 mb-1 pb-0`}
                          >
                            <Attendance
                              data={programDetails}
                              handleAttendance={handleAttendance}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
          }
        </Container>
      </section>
    </>
  );
};

export default ChatterProgramFilesDetail;

const fileIcon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.5">
    <mask id="mask0_5385_24336" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5385_24336)">
      <path d="M3.75 8.99991C3.75 10.1624 4.07812 11.203 4.73438 12.1218C5.39062 13.0405 6.25625 13.6687 7.33125 14.0062C7.55625 14.0812 7.74062 14.2218 7.88437 14.428C8.02812 14.6343 8.1 14.8624 8.1 15.1124C8.1 15.4749 7.94688 15.7624 7.64062 15.9749C7.33437 16.1874 7 16.2312 6.6375 16.1062C5.0875 15.5937 3.84375 14.6874 2.90625 13.3874C1.96875 12.0874 1.5 10.6249 1.5 8.99991C1.5 7.37491 1.96875 5.91241 2.90625 4.61241C3.84375 3.31241 5.0875 2.40616 6.6375 1.89366C7 1.76866 7.33437 1.81241 7.64062 2.02491C7.94688 2.23741 8.1 2.52491 8.1 2.88741C8.1 3.13741 8.02812 3.36554 7.88437 3.57179C7.74062 3.77804 7.55625 3.91866 7.33125 3.99366C6.25625 4.33116 5.39062 4.95929 4.73438 5.87804C4.07812 6.79679 3.75 7.83741 3.75 8.99991ZM14.2875 14.2874C13.8875 14.6999 13.4344 15.0593 12.9281 15.3655C12.4219 15.6718 11.8938 15.9187 11.3438 16.1062C10.9812 16.2312 10.6469 16.1874 10.3406 15.9749C10.0344 15.7624 9.88125 15.4749 9.88125 15.1124C9.88125 14.8624 9.95312 14.6343 10.0969 14.428C10.2406 14.2218 10.425 14.0812 10.65 14.0062C11.0375 13.8812 11.4094 13.7093 11.7656 13.4905C12.1219 13.2718 12.4438 13.0187 12.7313 12.7312C13.0188 12.4312 13.2688 12.1093 13.4813 11.7655C13.6938 11.4218 13.8688 11.0499 14.0063 10.6499C14.0813 10.4249 14.2219 10.2405 14.4281 10.0968C14.6344 9.95304 14.8625 9.88116 15.1125 9.88116C15.475 9.88116 15.7625 10.0343 15.975 10.3405C16.1875 10.6468 16.2313 10.9812 16.1063 11.3437C15.9188 11.8937 15.6719 12.4187 15.3656 12.9187C15.0594 13.4187 14.7 13.8749 14.2875 14.2874ZM14.2875 3.71241C14.7 4.12491 15.0594 4.58116 15.3656 5.08116C15.6719 5.58116 15.9188 6.10616 16.1063 6.65616C16.2313 7.01866 16.1875 7.35304 15.975 7.65929C15.7625 7.96554 15.475 8.11866 15.1125 8.11866C14.8625 8.11866 14.6344 8.04679 14.4281 7.90304C14.2219 7.75929 14.0813 7.57491 14.0063 7.34991C13.8688 6.94991 13.6938 6.57804 13.4813 6.23429C13.2688 5.89054 13.0188 5.56866 12.7313 5.26866C12.4438 4.98116 12.1219 4.72804 11.7656 4.50929C11.4094 4.29054 11.0375 4.11866 10.65 3.99366C10.425 3.91866 10.2406 3.77804 10.0969 3.57179C9.95312 3.36554 9.88125 3.13741 9.88125 2.88741C9.88125 2.52491 10.0344 2.23741 10.3406 2.02491C10.6469 1.81241 10.9812 1.76866 11.3438 1.89366C11.8938 2.08116 12.4219 2.32804 12.9281 2.63429C13.4344 2.94054 13.8875 3.29991 14.2875 3.71241Z" fill="#071E3E" />
      <mask id="mask1_5385_24336" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="3" y="3" width="12" height="12">
        <rect x="3.75" y="3.75" width="10.604" height="10.604" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_5385_24336)">
        <path d="M9.05164 6.84351C8.80863 6.84351 8.6006 6.75698 8.42755 6.58393C8.25449 6.41088 8.16797 6.20285 8.16797 5.95984C8.16797 5.71683 8.25449 5.5088 8.42755 5.33575C8.6006 5.1627 8.80863 5.07617 9.05164 5.07617C9.29464 5.07617 9.50267 5.1627 9.67573 5.33575C9.84878 5.5088 9.9353 5.71683 9.9353 5.95984C9.9353 6.20285 9.84878 6.41088 9.67573 6.58393C9.50267 6.75698 9.29464 6.84351 9.05164 6.84351ZM9.05164 13.0292C8.86754 13.0292 8.71106 12.9647 8.58219 12.8359C8.45332 12.707 8.38889 12.5505 8.38889 12.3664V8.38992C8.38889 8.20583 8.45332 8.04934 8.58219 7.92048C8.71106 7.79161 8.86754 7.72717 9.05164 7.72717C9.23573 7.72717 9.39222 7.79161 9.52108 7.92048C9.64995 8.04934 9.71439 8.20583 9.71439 8.38992V12.3664C9.71439 12.5505 9.64995 12.707 9.52108 12.8359C9.39222 12.9647 9.23573 13.0292 9.05164 13.0292Z" fill="#071E3E" />
      </g>
    </g>
  </g>
</svg>

const PresentIcon = () => {

  return (<svg
    style={{ cursor: "pointer" }}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
      fill="#16BF12"
    />
  </svg>)
}

const AbsentIcon = () => {

  return (
    <svg
      style={{ cursor: "pointer" }}
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_5342_36802" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5342_36802)">
        <path d="M12 21C10.7468 21 9.58226 20.763 8.49619 20.2943C7.39072 19.8173 6.43908 19.1749 5.63211 18.3679C4.82514 17.5609 4.18269 16.6093 3.70567 15.5038C3.23702 14.4177 3 13.2532 3 12C3 10.7468 3.23702 9.58226 3.70567 8.49619C4.18269 7.39072 4.82514 6.43908 5.63211 5.63211C6.43908 4.82514 7.39072 4.18269 8.49619 3.70567C9.58226 3.23702 10.7468 3 12 3C13.2532 3 14.4177 3.23702 15.5038 3.70567C16.6093 4.18269 17.5609 4.82514 18.3679 5.63211C19.1749 6.43908 19.8173 7.39072 20.2943 8.49619C20.763 9.58226 21 10.7468 21 12C21 13.2532 20.763 14.4177 20.2943 15.5038C19.8173 16.6093 19.1749 17.5609 18.3679 18.3679C17.5609 19.1749 16.6093 19.8173 15.5038 20.2943C14.4177 20.763 13.2532 21 12 21Z" fill="#ECECEC" stroke="#16BF12" stroke-width="2" />
      </g>
    </svg>
  )
}